export const GET_EQUITY_TYPE_DROPDOWN_REQUEST = 'GET_EQUITY_TYPE_DROPDOWN_REQUEST';
export const GET_EQUITY_TYPE_DROPDOWN_SUCCESS = 'GET_EQUITY_TYPE_DROPDOWN_SUCCESS';
export const GET_EQUITY_TYPE_DROPDOWN_FAILURE = 'GET_EQUITY_TYPE_DROPDOWN_FAILURE';
